import React from 'react';
import theme from '../config/theme';

function HoverButton({
  children,
  onClick,
  disabled = false,
  baseColor,
  hoverColor,
  gradient,
  hoverGradient,
  className = "",
  style = {},
  ...props
}) {
  const handleMouseEnter = (e) => {
    if (disabled) return;
    if (hoverGradient) {
      e.target.style.background = hoverGradient;
    } else if (hoverColor) {
      e.target.style.backgroundColor = hoverColor;
    }
  };

  const handleMouseLeave = (e) => {
    if (disabled) return;
    if (gradient) {
      e.target.style.background = gradient;
    } else if (baseColor) {
      e.target.style.backgroundColor = baseColor;
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={{
        ...(gradient ? { background: gradient } : { backgroundColor: baseColor }),
        ...style
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
    </button>
  );
}

export const PrimaryButton = ({ children, ...props }) => (
  <HoverButton
    baseColor={theme.colors.primary}
    hoverColor={theme.colors.primaryHover}
    style={{ color: theme.colors.text.button }}
    {...props}
  >
    {children}
  </HoverButton>
);

export const SecondaryButton = ({ children, ...props }) => (
  <HoverButton
    baseColor={theme.colors.secondary}
    hoverColor={theme.colors.hover.light}
    style={{ color: theme.colors.text.primary }}
    {...props}
  >
    {children}
  </HoverButton>
);

export const PaginationButton = ({ children, disabled, ...props }) => (
  <HoverButton
    baseColor={disabled ? theme.colors.accent : theme.colors.primary}
    hoverColor={disabled ? theme.colors.accent : theme.colors.secondary}
    disabled={disabled}
    className="px-4 py-2 text-white rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
    {...props}
  >
    {children}
  </HoverButton>
);

// Generic hover container for non-button elements
export function HoverCard({ children, isSelected, as = 'div', className = "", style = {}, ...props }) {
  const Component = as;
  
  const handleMouseEnter = (e) => {
    if (!isSelected) {
      e.currentTarget.style.backgroundColor = theme.colors.hover.light;
    }
  };

  const handleMouseLeave = (e) => {
    if (!isSelected) {
      e.currentTarget.style.backgroundColor = 'transparent';
    }
  };

  return (
    <Component
      className={className}
      style={{
        backgroundColor: isSelected ? `${theme.colors.primary}10` : 'transparent',
        ...style
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...props}
    >
      {children}
    </Component>
  );
}

export default HoverButton;